import type { ConnectFormProps } from './types';

const isDevEnv = process.env.REACT_APP_API_URL.includes('dev-api');

const getBaseUrl = (form: ConnectFormProps) => {
  if (form.override_script_source) {
    return form.override_script_source === 'dev'
      ? 'https://dev-cdn.nextlevel.ai/widgets'
      : 'https://uat-cdn.nextlevel.ai/widgets';
  }

  return isDevEnv
    ? 'https://dev-cdn.nextlevel.ai/widgets'
    : 'https://uat-cdn.nextlevel.ai/widgets';
};

const getUsesDev = (form: ConnectFormProps) => {
  if (form.override_agent_source) {
    return form.override_agent_source === 'dev';
  }

  return isDevEnv;
};

const getWidgetType = (form: ConnectFormProps) => {
  return form.use_video_avatar
    ? 'fullscreen_video.html'
    : 'ai_conference_call.html';
};

export const createWidgetHostUrl = (form: ConnectFormProps): string => {
  if (form.override_url?.trim()) return form.override_url;

  const baseUrl = `${getBaseUrl(form)}/${getWidgetType(form)}`;
  const params = new URLSearchParams({
    agentId: form.override_agent_id || form.agent_id,
  });
  getUsesDev(form) && params.append('useDev', 'true');

  const { bg_info_id, knowledgeBaseId, presentation_id } = form;
  bg_info_id && params.append('bg_info_id', bg_info_id);
  presentation_id && params.append('presentation_id', presentation_id);
  knowledgeBaseId && params.append('knowledgeBaseId', knowledgeBaseId);

  return `${baseUrl}?${params.toString()}`;
};
